module.exports = __webpack_public_path__ + "static/media/mv.44a3b21f.svg";